/* ==========================================================================
   Mundo Dos Filtros — entrega-prazo.js
   Data de entrega prometida e o selo que alterna entre "Frete grátis" e o
   prazo. Carrega antes de entrega-cep.js, que reaproveita o mesmo cálculo:
   duas contas separadas para a mesma promessa acabariam divergindo.
   ========================================================================== */

(function () {
  'use strict';

  var tema = (window.tema = window.tema || {});
  var textos = (tema.textos && tema.textos.entrega) || {};

  /* ------------------------------------------------------------- Prazo -- */

  /* O dia da semana precisa ser o da loja, não o do relógio de quem acessa:
     alguém em outro fuso poderia ver "sexta" numa quinta e receber a promessa
     errada. Montamos a data já convertida para o horário de Brasília. */
  function hojeNaLoja() {
    var agora = new Date();
    try {
      var partes = new Intl.DateTimeFormat('en-CA', {
        timeZone: 'America/Sao_Paulo',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
      }).format(agora);
      /* Meio-dia: longe das viradas de dia, então somar dias nunca escorrega
         para a data anterior por causa de horário de verão. */
      var data = new Date(partes + 'T12:00:00');
      if (!isNaN(data.getTime())) return data;
    } catch (erro) {
      /* Navegador sem suporte a fuso nomeado: seguimos com o relógio local. */
    }
    agora.setHours(12, 0, 0, 0);
    return agora;
  }

  /* Hora do dia na loja (0-23), não a de quem acessa — mesmo motivo do fuso
     fixo em hojeNaLoja(): o corte das 18h precisa valer para Brasília. */
  function horaNaLoja() {
    try {
      var hora = new Intl.DateTimeFormat('en-US', {
        timeZone: 'America/Sao_Paulo',
        hour: 'numeric',
        hour12: false
      }).format(new Date());
      var numero = parseInt(hora, 10);
      if (!isNaN(numero)) return numero % 24;
    } catch (erro) {
      /* Navegador sem suporte a fuso nomeado: segue com a hora local. */
    }
    return new Date().getHours();
  }

  /* Segunda a quinta o pedido sai no mesmo dia e chega em até 24h — mas só
     até as 18h, hora de corte da expedição. Depois disso o pedido só sai no
     dia seguinte, e a promessa vira 48h. Sexta, sábado e domingo caem fora
     da janela de expedição, então a promessa é a terça-feira seguinte.

     Quinta depois das 18h não entra no 48h: o pedido só sairia na sexta, e
     pedido de sexta segue a regra do fim de semana. Prometer 48h ali dava
     sábado, dia em que não entregamos. */
  function segundaAQuinta() {
    var diaSemana = hojeNaLoja().getDay();
    return diaSemana >= 1 && diaSemana <= 4;
  }

  function segundaAQuarta() {
    var diaSemana = hojeNaLoja().getDay();
    return diaSemana >= 1 && diaSemana <= 3;
  }

  function apos18h() {
    return horaNaLoja() >= 18;
  }

  function ate24h() {
    return segundaAQuinta() && !apos18h();
  }

  function ate48h() {
    return segundaAQuarta() && apos18h();
  }

  /* A regra acima dá a data MÍNIMA. O caminhão só passa em cada região nos
     dias do roteiro (dias = dias da semana, 0 = domingo), então a entrega é o
     primeiro dia de rota a partir dela. Sem dias (região ainda desconhecida),
     vale a data mínima, que é a das regiões atendidas todo dia. */
  function dataDeEntrega(dias) {
    var hoje = hojeNaLoja();
    var diaSemana = hoje.getDay();

    var TERCA = 2;
    var somar;
    if (ate24h()) {
      somar = 1;
    } else if (ate48h()) {
      somar = 2;
    } else {
      somar = (TERCA - diaSemana + 7) % 7;
    }

    var entrega = new Date(hoje.getTime());
    entrega.setDate(entrega.getDate() + somar);

    if (dias && dias.length) {
      while (dias.indexOf(entrega.getDay()) === -1) entrega.setDate(entrega.getDate() + 1);
    }

    return entrega;
  }

  /* ----------------------------------------------------------- Roteiro -- */

  /* Roteiro de Entregas do caminhão (planilha "ROTEIRO ENTREGAS CAMINHAO").
     A mesma tabela existe no robô, em src/entrega/roteiro.ts: mudou o roteiro,
     mude os dois.

     No DF o ViaCEP devolve "Brasília" como cidade e a região no bairro, às
     vezes com a RA entre parênteses ("Setor Leste (Gama)"). Os ESPECIAIS são
     setores que têm dia próprio dentro de uma RA de outro dia (Taquari fica no
     Lago Norte, que é diário, mas o caminhão só vai lá terça e sexta), por isso
     são procurados antes das RAs. */
  var DIAS = {
    diario: [1, 2, 3, 4, 5],
    terca_sexta: [2, 5],
    quarta: [3],
    quinta: [4]
  };

  var ESPECIAIS = [
    ['terca_sexta', [
      'taquari', 'lago oeste', 'mansoes dom bosco', 'setor de mansoes do lago norte',
      'solar de brasilia', 'solar da serra', 'altiplano leste', 'alto plano leste',
      'alti plano leste', 'grande colorado', 'mangueiral', 'jardim botanico',
      'itaipu', 'alphaville', 'ville montagne', 'ouro vermelho', 'quintas do trevo',
      'quintas da alvorada', 'santa monica', 'mini chacaras', 'prive', 'monaco',
      'condominio rk'
    ]],
    ['quarta', ['porto rico', 'santos dumont', 'ponte alta']],
    ['quinta', ['incra', 'alexandre gusmao']]
  ];

  var REGIOES_DF = [
    ['diario', [
      'aguas claras', 'arniqueira', 'areal', 'asa norte', 'asa sul', 'noroeste',
      'vila planalto', 'ceilandia', 'cruzeiro', 'estrutural', 'guara', 'lago norte',
      'setor de habitacoes individuais norte', 'lago sul',
      'setor de habitacoes individuais sul', 'nucleo bandeirante', 'octogonal',
      'recanto das emas', 'riacho fundo', 'samambaia', 'industria e abastecimento',
      'setor militar urbano', 'sudoeste', 'taguatinga', 'vicente pires', 'caub', 'varjao'
    ]],
    ['terca_sexta', ['arapoanga', 'fercal', 'paranoa', 'planaltina', 'sao sebastiao', 'sobradinho', 'itapoa']],
    ['quarta', ['gama', 'santa maria']],
    ['quinta', ['brazlandia']]
  ];

  function normalizar(texto) {
    return (texto || '')
      .normalize('NFD')
      .replace(/[̀-ͯ]/g, '')
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, ' ')
      .trim();
  }

  function procurar(lista, texto) {
    var alvo = ' ' + texto + ' ';
    for (var i = 0; i < lista.length; i++) {
      var nomes = lista[i][1];
      for (var j = 0; j < nomes.length; j++) {
        if (alvo.indexOf(' ' + nomes[j] + ' ') !== -1) return lista[i][0];
      }
    }
    return null;
  }

  /* Dias de rota do endereço ({ uf, localidade, bairro } do ViaCEP), ou null
     quando o endereço é atendido mas a região não está na planilha (Park Way,
     por exemplo): aí o site não promete data. Em Goiás, Planaltina vai terça e
     sexta e as demais cidades atendidas, na quinta. */
  function diasDoEndereco(dados) {
    var uf = (dados.uf || '').toUpperCase();
    var grupo = null;
    if (uf === 'GO') {
      grupo = normalizar(dados.localidade) === 'planaltina' ? 'terca_sexta' : 'quinta';
    } else if (uf === 'DF') {
      var bairro = normalizar(dados.bairro);
      grupo = procurar(ESPECIAIS, bairro) || procurar(REGIOES_DF, bairro);
    }
    return grupo ? DIAS[grupo] : null;
  }

  /* Dias de rota do CEP que a pessoa já consultou (guardado por entrega-cep.js).
     É o que deixa o selo dos cards certo para quem mora numa região de dia
     fixo. */
  function diasSalvos() {
    try {
      var estado = JSON.parse(window.localStorage.getItem('mdf-entrega-cep'));
      return estado && estado.atende && estado.dias ? estado.dias : null;
    } catch (erro) {
      return null;
    }
  }

  /* Duas datas são o mesmo dia? Compara só ano, mês e dia: as duas já vêm
     ancoradas ao meio-dia, mas o horário nunca importa para essa pergunta. */
  function mesmoDia(a, b) {
    return (
      a.getFullYear() === b.getFullYear() &&
      a.getMonth() === b.getMonth() &&
      a.getDate() === b.getDate()
    );
  }

  /* "terça-feira" vira "terça": a frase é curta e cabe numa linha só, e ninguém
     fala o dia por extenso. Sábado e domingo não têm o sufixo e passam intactos.

     De segunda a quinta a entrega cai sempre no dia seguinte, e aí "amanhã" diz
     mais que "quarta, 12/08": ninguém precisa conferir o calendário para saber
     o que isso significa. Para as esperas maiores — pedido feito de sexta a
     domingo, que só chega na terça — o dia da semana volta, porque aí a data
     é justamente a informação que falta. */
  function formatarDataEntrega(data) {
    var amanha = hojeNaLoja();
    amanha.setDate(amanha.getDate() + 1);
    if (mesmoDia(data, amanha) && textos.amanha) return textos.amanha;

    try {
      var texto = new Intl.DateTimeFormat('pt-BR', {
        weekday: 'long',
        day: '2-digit',
        month: '2-digit'
      }).format(data);
      return texto.replace('-feira', '');
    } catch (erro) {
      return ('0' + data.getDate()).slice(-2) + '/' + ('0' + (data.getMonth() + 1)).slice(-2);
    }
  }

  function preencher(modelo, valores) {
    var saida = modelo || '';
    Object.keys(valores || {}).forEach(function (chave) {
      saida = saida.replace(new RegExp('\\{\\{\\s*' + chave + '\\s*\\}\\}', 'g'), valores[chave]);
    });
    return saida;
  }

  /* De segunda a quinta antes das 18h o "24h" diz tudo. Depois das 18h vira
     "48h", porque o pedido só sai no dia seguinte. No fim de semana os dois
     seriam mentira, então trocamos pela data concreta em que a encomenda
     chega. */
  function textoPrazo() {
    /* Região com dia fixo e data diferente da regra geral: o "24h" seria
       mentira, então vai a data concreta. */
    var dias = diasSalvos();
    if (dias && !mesmoDia(dataDeEntrega(dias), dataDeEntrega())) {
      return preencher(textos.selo_data, { data: formatarDataEntrega(dataDeEntrega(dias)) });
    }
    if (ate24h()) return textos.selo_24h || '';
    if (ate48h()) return textos.selo_48h || '';
    return preencher(textos.selo_data, { data: formatarDataEntrega(dataDeEntrega()) });
  }

  /* Prazo fixo (produto com tag entrega-lenta-N): hoje + N dias, sem
     depender de dia da semana. O nome do dia não ajuda quando a espera já
     é de semanas: só a data importa. */
  function dataFixa(dias) {
    var alvo = new Date(hojeNaLoja().getTime());
    alvo.setDate(alvo.getDate() + dias);
    return alvo;
  }

  function formatarDataSimples(data) {
    return ('0' + data.getDate()).slice(-2) + '/' + ('0' + (data.getMonth() + 1)).slice(-2);
  }

  function textoFixo(dias) {
    return 'Chega em até ' + dias + ' dias (até ' + formatarDataSimples(dataFixa(dias)) + ')';
  }

  tema.prazo = {
    hoje: hojeNaLoja,
    ate24h: ate24h,
    ate48h: ate48h,
    data: dataDeEntrega,
    diasDoEndereco: diasDoEndereco,
    formatar: formatarDataEntrega,
    texto: textoPrazo,
    dataFixa: dataFixa,
    formatarSimples: formatarDataSimples,
    textoFixo: textoFixo,
    /* Chamado por entrega-cep.js logo depois de consultar o CEP: o selo já
       troca para a data da região, sem esperar a próxima volta do rodízio. */
    repintar: function () {
      var prazo = textoPrazo();
      if (prazo) pintar(selosNaPagina(), prazo);
    }
  };

  /* -------------------------------------------------------------- Selo -- */

  var INTERVALO = 3500;
  var indice = 0;

  /* A busca é refeita a cada volta, e não uma vez só no carregamento: card de
     coleção filtrada, "carregar mais" e troca de variante inserem selos novos
     depois, e eles precisam entrar no rodízio junto com os que já estavam. */
  function selosNaPagina() {
    return Array.prototype.slice.call(document.querySelectorAll('[data-selo-entrega]'));
  }

  function pintar(selos, prazo) {
    selos.forEach(function (selo) {
      var diasFixo = parseInt(selo.getAttribute('data-selo-fixo'), 10);
      var valor = diasFixo > 0 ? textoFixo(diasFixo) : prazo;
      var campo = selo.querySelector('[data-selo-prazo]');
      if (campo && campo.textContent !== valor) campo.textContent = valor;

      var itens = selo.querySelectorAll('[data-selo-item]');
      if (itens.length < 2) return;
      for (var i = 0; i < itens.length; i++) {
        itens[i].classList.toggle('selo-entrega__item--ativo', i === indice);
      }
    });
  }

  var relogio = null;

  function pararRodizio() {
    if (relogio) window.clearInterval(relogio);
    relogio = null;
  }

  /* Um único cronômetro para todos os selos da página: numa coleção com 24
     produtos, 24 setInterval independentes deixariam as trocas fora de sincronia
     e a grade inteira piscando em tempos diferentes.

     Quem pede menos movimento continua vendo os dois textos se alternando —
     trocar palavra não é animação. O que o CSS desliga nesse caso é só o
     esmaecimento entre um e outro. */
  function girarSelos() {
    var prazo = textoPrazo();

    /* Sem texto de prazo não há para onde alternar: o selo fica no frete grátis,
       que é o estado que já veio do Liquid. */
    if (!prazo) return;

    pintar(selosNaPagina(), prazo);

    /* Aba escondida não precisa de rodízio: eram 144 trocas de classe a cada
       3,5s rodando para ninguém, e a cada volta um recálculo de estilo na
       página inteira. */
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) {
        pararRodizio();
      } else if (!relogio) {
        agendarRodizio(prazo);
      }
    });

    agendarRodizio(prazo);
  }

  function agendarRodizio(prazo) {
    pararRodizio();
    relogio = window.setInterval(function () {
      var selos = selosNaPagina();
      if (!selos.length) return;
      indice = indice === 0 ? 1 : 0;
      /* Recalculado a cada volta: a pessoa pode consultar o CEP agora e
         descobrir que mora numa região de dia fixo. */
      pintar(selos, textoPrazo() || prazo);
    }, INTERVALO);
  }

  /* O texto certo do selo é escrito assim que o HTML fica de pé — é conteúdo,
     e esperar seria deixar a informação errada na tela.

     Já o rodízio entre "Frete grátis" e o prazo só começa depois do load. Ele
     mexe em texto visível a cada 3,5s: começando cedo, a área visível fica
     mudando durante toda a medição e o navegador nunca dá a primeira dobra por
     pronta — era isso que inflava o Speed Index. */
  function comecar() {
    var prazo = textoPrazo();
    if (prazo) pintar(selosNaPagina(), prazo);

    if (document.readyState === 'complete') {
      girarSelos();
    } else {
      window.addEventListener('load', girarSelos, { once: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', comecar);
  } else {
    comecar();
  }
})();
